import { apiUrl } from '../config';

const calculationUrl = `${apiUrl}/calculation`;

const urls = {
  calculation: {
    rtw: `${calculationUrl}/rtw`,
    tma: `${calculationUrl}/tma`,
    twtma: `${calculationUrl}/twtma`,
    fma: `${calculationUrl}/fma`,
    twfma: `${calculationUrl}/twfma`,
    fujisawa: `${calculationUrl}/fujisawa`,
    desiredFinishPoint: `${calculationUrl}/desired-finish-point`,
    overallCorrection: `${calculationUrl}/overall-correction`,
    wedgeMeasurements: `${calculationUrl}/wedge-measurements`,
  },
  email: `${apiUrl}/emailMessage`,
  newUserNotification: `${apiUrl}/newUserEmail`,
  exportCase: `${apiUrl}/cases/export`,
  verifyEmail: `${apiUrl}/verifyEmail`,
  createUser: `${apiUrl}/users/create`,
  updateUser: `${apiUrl}/users/update`,
  getUsers: `${apiUrl}/users/get-all`,
  sendVerification: `${apiUrl}/users/send-verification`,
  resetPassword: `${apiUrl}/users/send-reset-password-email`,
  disableUser: `${apiUrl}/users/disable-user`,
  disable2FA: `${apiUrl}/users/disable-2fa`,
  ghostLogin: `${apiUrl}/users/ghost-login`,
  ghostRestore: `${apiUrl}/users/ghost-restore`,
  sendSms: `${apiUrl}/cases/send-sms`,
  sendPushNotification: `${apiUrl}/cases/send-push-notification`,
  getPaginatedCases: `${apiUrl}/cases/get-paginated-cases`,
  getCases: `${apiUrl}/cases/get-cases`,
  // sendPushNotification: `${apiUrl}/sendPushNotification`,
};

export default urls;
